import { useStore } from 'zustand';

import { settingsStore, type SettingsState } from './settings-store';

export function useSettingsStore<T>(selector: (state: SettingsState) => T): T {
  return useStore(settingsStore, selector);
}
